const ENV = {
  redirectUrl: "REACT_APP_REDIRECT_URL",
  clientId: "REACT_APP_B2C_CLIENT_ID",
  authority: "REACT_APP_B2C_AUTHORITY",
  knownAuthority: "REACT_APP_B2C_KNOWN_AUTHORITY",
  redirectUri: "REACT_APP_B2C_REDIRECT_URI",
  scopes: "REACT_APP_B2C_SCOPES",
};

const values = {
  redirectUrl: process.env.REACT_APP_REDIRECT_URL,
  clientId: process.env.REACT_APP_B2C_CLIENT_ID,
  authority: process.env.REACT_APP_B2C_AUTHORITY,
  knownAuthority: process.env.REACT_APP_B2C_KNOWN_AUTHORITY,
  redirectUri: process.env.REACT_APP_B2C_REDIRECT_URI,
  scopes: process.env.REACT_APP_B2C_SCOPES,
};

export function loadConfig() {
  const missing = Object.keys(values)
    .filter((key) => !values[key] || !String(values[key]).trim())
    .map((key) => ENV[key]);

  if (missing.length > 0) {
    throw new Error(
      "No configuration found. Missing required variable(s): " +
        missing.join(", ") +
        ". Provide them via Docker --build-arg / an env file before building."
    );
  }

  return {
    redirectUrl: values.redirectUrl,
    msalConfig: {
      auth: {
        clientId: values.clientId,
        authority: values.authority,
        knownAuthorities: [values.knownAuthority],
        redirectUri: values.redirectUri,
        postLogoutRedirectUri: values.redirectUri,
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    },

    loginRequest: {
      scopes: values.scopes
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    },
  };
}
